import { IEnv } from "./env.type";

export const Env: IEnv = (window as any).config;
